module.exports = __webpack_public_path__ + "img/stratingicon.ddf735bc.svg";